import RoutesApp from './router';



export default function App(){
  return(
    <div className="app">
      <RoutesApp />
    </div>
  )
}